/**
 * Email validation utility
 * Mirrors backend utils.validators.validate_email pattern with user-facing errors.
 */

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * @param {string} value
 * @returns {{ isValid: boolean, error: string|null }}
 */
export const validateEmailAddress = (value) => {
  if (!value || typeof value !== 'string') {
    return { isValid: false, error: 'Email address is required.' };
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return { isValid: false, error: 'Email address is required.' };
  }

  if (!EMAIL_PATTERN.test(trimmed)) {
    return { isValid: false, error: 'Please enter a valid email address (e.g., name@example.com).' };
  }

  return { isValid: true, error: null };
};

export default {
  validateEmailAddress,
};
